<template>
    <!-- <div v-if="banner && ((pc && detect == 'pc') || (mobile && detect == 'mobile'))" class="main-visual swiper-container"> -->
    <div class="main-visual">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <img src="/images/main/visual01.jpg" alt="" class="visual-img" />
                    <v-container class="white--text">
                        <h2 class="tit tit--xl mb-24">GOOD MOOD FOOD, MO DOO!</h2>
                        <p class="page-text page-text--lg font-weight-medium">
                            신선한 재료 엄선, 건강한 식자재 공급.<br />
                            식자재 유통의 모두! 최대한 모든 식자재를 다양한 방법으로 유통합니다.
                        </p>
                        <div class="swiper-control">
                            <div class="swiper-pagination"></div>
                        </div>
                    </v-container>
                </div>

                <div class="swiper-slide">
                    <img src="/images/main/visual02.jpg" alt="" class="visual-img" />
                    <v-container class="white--text">
                        <h2 class="tit tit--xl mb-24">One stop shopping!</h2>
                        <p class="page-text page-text--lg font-weight-medium">
                            식자재 전제품 세팅을 한번에! All in one!<br />
                            2000여가지의 다수 제품 보유, 가격의 차별화와 경쟁력을 가지고 있습니다.
                        </p>
                        <div class="swiper-control">
                            <div class="swiper-pagination"></div>
                        </div>
                    </v-container>
                </div>

                <div class="swiper-slide">
                    <img src="/images/main/visual03.jpg" alt="" class="visual-img" />
                    <v-container class="white--text">
                        <h2 class="tit tit--xl mb-24">Every food&total services</h2>
                        <p class="page-text page-text--lg font-weight-medium">
                            소상공인부터 프랜차이즈 또는 레스토랑 그리고 요식업계열 대기업까지 <br class="d-none d-md-block" />
                            26년간의 노하우로 좋은 품질의 제품을 보다 빠르게 공급합니다.
                        </p>
                        <div class="swiper-control">
                            <div class="swiper-pagination"></div>
                        </div>
                    </v-container>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api";
import Swiper from "swiper/bundle";
import detect from "@/plugins/detect";
export default {
    props: {
        pc: Boolean,
        mobile: Boolean,
    },
    data() {
        return {
            detect,
            banner: null,
            visuals: [
                { link: "javascript:", pc: "/images/main/v1.jpg", mo: "/images/main/v1-mo.jpg" },
                { link: "javascript:", pc: "/images/main/v2.jpg", mo: "/images/main/v2-mo.jpg" },
                { link: "javascript:", pc: "/images/main/v3.jpg", mo: "/images/main/v3-mo.jpg" },
            ],
            swiper: undefined,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {
                this.Swiper = new Swiper(".main-visual .swiper-container", {
                    effect: "fade",
                    speed: 500,
                    loop: true,
                    autoplay: {
                        delay: 8000,
                        disableOnInteraction: false,
                    },
                    pagination: {
                        el: ".main-visual .swiper-pagination",
                        clickable: true,
                        renderBullet: function(index, className) {
                            return '<span class="' + className + ' swiper-pagination-bullet--svg-animation"><svg class="stroke-animation" viewBox="0 0 40 40"><circle cx="20" cy="20" r="20.5"></circle></svg></span>';
                        },
                    },
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.main-visual {
    height: calc(50vh - var(--header-body));
    margin-top: var(--header-body);
    width: 100%;
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .main-visual {
        height: calc(100vh - var(--header-body));
    }
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}

/* main-visual animation */
@keyframes stroke-ani {
    from {
        stroke-dashoffset: 126;
    }
    to {
        stroke-dashoffset: 0;
    }
}

::v-deep {
    .swiper-container {
        .swiper-wrapper {
            .swiper-slide {
                width: 100%;
                position: relative;
                .visual-img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
                .container {
                    height: 235px;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    .swiper-control {
                        position: absolute;
                        left: 12px;
                        bottom: 0;
                        height: 40px;
                        .swiper-pagination-bullet {
                            position: relative;
                            opacity: 0.5;
                            width: 32px;
                            height: 32px;
                            background: transparent;
                            .stroke-animation {
                                opacity: 0;
                            }
                            &::before {
                                content: "";
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                                border-radius: 50%;
                                width: 8px;
                                height: 8px;
                                background: #fff;
                            }
                            &-active {
                                width: 40px;
                                height: 40px;
                                box-sizing: border-box;
                                border: 1px solid #fff;
                                opacity: 1;
                                &::after {
                                    content: "";
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    transform: translate(-50%, -50%);
                                    border-radius: 50%;
                                    width: 40px;
                                    height: 40px;
                                    z-index: 1;
                                }
                                .stroke-animation {
                                    opacity: 1;
                                    overflow: visible;
                                    transform: rotate(-90deg);
                                    circle {
                                        fill: transparent;
                                        stroke: var(--v-grey-lighten1);
                                        stroke-width: 1;
                                        stroke-dasharray: 126;
                                        animation-name: stroke-ani;
                                        animation-duration: 8s;
                                        animation-timing-function: linear;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
